export var GdprConsentFromInvitationError;
(function (GdprConsentFromInvitationError) {
    GdprConsentFromInvitationError["notFound"] = "password-reset-not-found";
    GdprConsentFromInvitationError["alreadyExists"] = "user-gdpr-consent-already-exists";
})(GdprConsentFromInvitationError || (GdprConsentFromInvitationError = {}));
var GdprConsentFromInvitationRequest = /** @class */ (function () {
    function GdprConsentFromInvitationRequest(token, gdprConsent, directMarketingConsent) {
        this.isAuthenticated = false;
        this.knownErrorCodes = Object.values(GdprConsentFromInvitationError);
        this.method = 'post';
        this.path = "users/gdpr-consent/from-password-reset/".concat(encodeURIComponent(token));
        this.body = JSON.stringify({
            termsConsent: gdprConsent,
            marketingConsent: directMarketingConsent,
        });
    }
    return GdprConsentFromInvitationRequest;
}());
export { GdprConsentFromInvitationRequest };
export var GdprConsentError;
(function (GdprConsentError) {
    GdprConsentError["alreadyExists"] = "user-gdpr-consent-already-exists";
})(GdprConsentError || (GdprConsentError = {}));
var GdprConsentRequest = /** @class */ (function () {
    function GdprConsentRequest(gdprConsent, directMarketingConsent) {
        this.isAuthenticated = true;
        this.knownErrorCodes = Object.values(GdprConsentError);
        this.method = 'post';
        this.path = "users/gdpr-consent/";
        this.body = JSON.stringify({
            termsConsent: gdprConsent,
            marketingConsent: directMarketingConsent,
        });
    }
    return GdprConsentRequest;
}());
export { GdprConsentRequest };
